import ReactMarkdown from 'react-markdown';
import styles from './render-chat-messages.module.scss';
import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Collapse, ConfigProvider } from 'antd';
import { useChatConversation } from '../../hooks/use-chat-conversation';

export function MessageReferences({ message }) {
  const { lang } = useChatConversation();
  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerPadding: 0,
            contentPadding: 0,
          },
        },
      }}
    >
      <Collapse
        bordered={false}
        className={styles.referencesCollapse}
        expandIcon={({ isActive }) => (
          <FontAwesomeIcon
            className={styles.referencesExpenderIcon}
            icon={faChevronRight}
            rotation={isActive ? 90 : 0}
          />
        )}
      >
        <Collapse.Panel header={<p className={styles.referencesHeader}>{lang.REFERENCES}</p>}>
          <div className={styles.referencesPanel}>
            {message.references.map(reference => (
              <RenderReference key={reference.id} reference={reference} />
            ))}
          </div>
        </Collapse.Panel>
      </Collapse>
    </ConfigProvider>
  );
}

export function RenderReference({ reference }) {
  const [expanded, setExpanded] = React.useState(false);
  const { lang } = useChatConversation();

  return (
    <div className={styles.reference}>
      <div className={classNames(styles.referenceContent, expanded && styles.expanded)}>
        <ReactMarkdown>{reference.content}</ReactMarkdown>
      </div>
      <button className={styles.expandedBtn} onClick={() => setExpanded(s => !s)}>
        {expanded ? lang.READ_LESS : lang.READ_MORE}
      </button>
    </div>
  );
}
